import events from "/events";

const RATIO = 150 / 267;
let modalResizerNode;
let modalNode;
let videoNode;
let youtubeId;
let modalId;
let isOpened;

export const initModalVideo = (id, code) => {
  modalId = id;
  youtubeId = code;

  events.on(`modal:${modalId}:opened`, () => {
    if (isOpened === modalId) {
      return;
    }
    isOpened = modalId;
    onModalOpen();
    events.track("body-20180711-homepage_video", "1-click", "open-video");
  });

  events.on(`modal:${modalId}:after-opened`, () => {
    onModalResize();
  });

  events.on(`modal:${modalId}:closed`, () => {
    isOpened = null;
    onModalClose();
    events.track("body-20180711-homepage_video", "1-click", "close-video");
  });
};

const onModalOpen = () => {
  modalNode = document.querySelector(`.modal--${modalId}`);
  videoNode = modalNode.querySelector(".modal-video");
  modalResizerNode = modalNode.querySelector(".modal__resizer");
  const iframe = createIFrame(youtubeId);
  videoNode.appendChild(iframe);
  window.addEventListener("resize", onModalResize);
  onModalResize();
};

const onModalClose = () => {
  window.removeEventListener("resize", onModalResize);
};

const createIFrame = (id) => {
  const iframe = document.createElement("iframe");
  const options = {
    autoplay: 1,
    // eslint-disable-next-line camelcase
    iv_load_policy: 3,
    rel: 0,
    color: "white",
    showinfo: 0
  };
  const optionsString = new URLSearchParams(options).toString();
  const src = `https://www.youtube.com/embed/${id}?${optionsString}`;
  iframe.setAttribute("src", src);
  iframe.setAttribute("frameborder", 0);
  iframe.setAttribute("allow", "autoplay; encrypted-media");
  iframe.setAttribute("allowfullscreen", "");

  iframe.style.width  = "100%";
  iframe.style.height = "100%";

  return iframe;
};

const onModalResize = () => {
  const sizes = getVideoSizes();
  videoNode.style.width = sizes.width + "px";
  videoNode.style.height = sizes.height + "px";
};

const getVideoSizes = () => {
  const baseRect = modalResizerNode.getBoundingClientRect();
  const baseRatio = baseRect.height / baseRect.width;
  let width, height;
  if (baseRatio > RATIO) {
    width = baseRect.width;
    height = width * RATIO;
  } else {
    height = baseRect.height;
    width = height / RATIO;
  }
  return { width: Math.floor(width), height: Math.floor(height) };
};
